export default function EvaluationListTranslation(fieldName, langcode = "en") {

    const fields = {
        filters: {
            en: {
                label: "Filters",
            },
            gr: {
                label: "Φίλτρα αναζήτησης",
            }
        },
        mandatoryFilters: {
            en: {
                label: "Mandatory filters",
            },
            gr: {
                label: "Υποχρεωτικά φίλτρα",
            }
        },
        optionalFilters: {
            en: {
                label: "Optional filters",
            },
            gr: {
                label: "Προαιρετικά φίλτρα",
            }
        },
        call: {
            en: {
                label: "Call",
            },
            gr: {
                label: "Κάλεσμα",
            }
        },
        mandatoryFiltersMessage: {
            en: {
                label: "Please fill in the mandatory filters",
            },
            gr: {
                label: "Παρακαλώ συμπληρώστε τα υποχρεωτικά φίλτρα",
            }
        },
        sorting: {
            en: {
                label: "Sorting",
            },
            gr: {
                label: "Ταξινόμηση",
            }
        },
        sorting_opts: {
            en: {
                label: [
                    { label: "Preference order ascending", value: "order_asc" },
                    { label: "Preference order descending", value: "order_desc" },
                    { label: "Ranking by university ascending", value: "evaluation_asc" },
                    { label: "Ranking by university descending", value: "evaluation_desc" }
                ],
            },
            gr: {
                label: [
                    { label: "Σειρά προτίμησης αύξουσα", value: "order_asc" },
                    { label: "Σειρά προτίμησης φθίνουσα", value: "order_desc" },
                    { label: "Κατάταξη ανά Πανεπιστήμιο αύξουσα", value: "evaluation_asc" },
                    { label: "Κατάταξη ανά Πανεπιστήμιο φθίνουσα", value: "evaluation_desc" }
                ],
            }
        },
        id: {
            en: {
                label: "Application number",
            },
            gr: {
                label: "Αριθμός αίτησης",
            }
        },
        status: {
            en: {
                label: "Status",
            },
            gr: {
                label: "Κατάσταση",
            }
        },
        date: {
            en: {
                label: "Submitted Date",
            },
            gr: {
                label: "Ημερομηνία υποβολής",
            }
        },
        fullName: {
            en: {
                label: "Full Name (Latin)",
            },
            gr: {
                label: "Ονοματεπώνυμο (Λατινικά)",
            }
        },
        fullNameGreek: {
            en: {
                label: "Full Name (Greek)",
            },
            gr: {
                label: "Ονοματεπώνυμο (Ελληνικά)",
            }
        },
        fullNameList: {
            en: {
                label: "Full Name",
            },
            gr: {
                label: "Ονοματεπώνυμο",
            }
        },
        type: {
            en: {
                label: "Type of mobility",
            },
            gr: {
                label: "Τύπος κινητικότητας",
            }
        },
        mobility: {
            en: {
                label: "Mobility Action",
            },
            gr: {
                label: "Δράση κινητικότητας",
            }
        },
        applicationDate: {
            en: {
                label: "Application Year",
            },
            gr: {
                label: "Έτος πρόσκλησης",
            }
        },
        actions: {
            en: {
                label: "Actions",
            },
            gr: {
                label: "Ενέργειες",
            }
        },
        department: {
            en: {
                label: "Department",
            },
            gr: {
                label: "Τμήμα",
            }
        },
        totalStudies: {
            en: {
                label: "Total number of applications: ",
            },
            gr: {
                label: "Συνολικός αριθμός αιτήσεων: ",
            }
        },
        noStudiesFound: {
            en: {
                label: "No applications found",
            },
            gr: {
                label: "Δεν υπάρχουν αιτήσεις προς επεξεργασία",
            }
        },
        status_opts: {
            en: {
                label: [{ label: "Draft", value: "Draft" }, { label: "Submitted", value: "Submitted" }, { label: "Validated", value: "Validated" }],
            },
            gr: {
                label: [{ label: "Αποθηκευμένη", value: "Αποθηκευμένη", original:"Draft" }, { label: "Καταχωρημένη", value: "Καταχωρημένη", original:"Submitted" }, { label: "Επικυρωμένη", value: "Επικυρωμένη",original:"Validated" }],
            }
        },
        type_opts: {
            en: {
                label: [{ label: "Long-term mobility for Studies", value: "Long-term mobility for Studies" }, { label: "Short-term mobility for Studies", value: "Short-term mobility for Studies" }],
            },
            gr: {
                label: [{ label: "Μακροχρόνια κινητικότητα για Σπουδές", value: "Μακροχρόνια κινητικότητα για Σπουδές" }, { label: "Βραχυχρόνια κινητικότητα για Σπουδές", value: "Βραχυχρόνια κινητικότητα για Σπουδές" }],
            }
        },
        mobility_opts: {
            en: {
                label: [{ label: "Erasmus+ Studies", value: "Erasmus+ Studies" }],
            },
            gr: {
                label: [{ label: "Erasmus+ Σπουδές", value: "Erasmus+ Σπουδές" }],
            }
        },
        erasmusCode:{
            en: {
                label: "Erasmus Code",
            },
            gr: {
                label: "Erasmus Code",
            }
        },
        universityName:{
            en: {
                label: "University",
            },
            gr: {
                label: "Πανεπιστήμιο",
            }
        },
        departmentalCoordinatorFilter: {
            en: {
                label: "Departmental coordinator",
            },
            gr: {
                label: "Υπεύθυνος συμφωνίας",
            }
        },
        order: {
            en: {
                label:  "Preference order"
            },
            gr: {
                label: "Σειρά προτίμησης" ,
            }
        },
        iia: {
            en: {
                label:  "Number of Mobilities/Total Months/Study Cycle"
            },
            gr: {
                label: "Αριθμός Μετακινούμενων/Αριθμός Μηνών/Επίπεδο Σπουδών" ,
            }
        },
        evaluation: {
            en: {
                label:  "Ranking by University"
            },
            gr: {
                label: "Κατάταξη ανά Πανεπιστήμιο" ,
            }
        },
        approval: {
            en: {
                label:  "Movement Approval"
            },
            gr: {
                label: "Έγκριση Μετακίνησης" ,
            }
        },
        documentNumber: {
            en: {
                label:  "Document Number"
            },
            gr: {
                label: "Αριθμός αίτησης" ,
            }
        },
        studySemester: {
            en: {
                label:  "Study Semester"
            },
            gr: {
                label: "Εξάμηνο σπουδών" ,
            }
        },
        country: {
            en: {
                label:  "Country"
            },
            gr: {
                label: "Χώρα" ,
            }
        },
        agreementOfficer: {
            en: {
                label:  "Αgreement Officer"
            },
            gr: {
                label: "Υπεύθυνος συμφωνίας" ,
            }
        },
        language: {
            en: {
                label:  "Language"
            },
            gr: {
                label: "Γλώσσα" ,
            }
        },
        languageLevel: {
            en: {
                label:  "Language Level"
            },
            gr: {
                label: "Επίπεδο γλώσσας (Δ1)" ,
            }
        },
        averageGrade: {
            en: {
                label:  "Average Grade"
            },
            gr: {
                label: "Μέσος όρος πτυχίου (Δ2*10)" ,
            }
        },
        studyYearWeight: {
            en: {
                label:  "Study Year Weight"
            },
            gr: {
                label: "Δείκτης έτους σπουδών (Δ4)" ,
            }
        },
        incentive: {
            en: {
                label:  "Incentive"
            },
            gr: {
                label: "Κίνητρα (Δ5)" ,
            }
        },
        comments: {
            en: {
                label:  "Comments"
            },
            gr: {
                label: "Σχόλια ECTS Coordinator" ,
            }
        }
    };

    return fields[fieldName][langcode];

}
